'use client';
import { useState } from 'react';
import { useInterval } from '../useInterval/useInterval.js';

var useTime = function(refreshRate) {
    if (refreshRate === void 0) refreshRate = 1000;
    var _useState = useState(Date.now()), time = _useState[0], setTime = _useState[1];
    useInterval(function() {
        return setTime(Date.now());
    }, refreshRate);
    return time;
};

export { useTime };
